import React from 'react';
import _ from 'lodash';

import FieldSelect from './FieldSelect.jsx';

export default function FieldSelectRating(props) {
  const options = _.times(props.limit, (i) => {
    const indexPlusOne = i + 1;
    const customDropDownDescription = _.get(props, 'dropdownDescriptions[indexPlusOne]');
    let value = _.toString(indexPlusOne);

    if (customDropDownDescription) {
      value += ` - ${customDropDownDescription}`;
    }

    return {
      slug: indexPlusOne,
      value,
    };
  });

  const getSelectedDefaultValue = () => {
    if (_.has(props, 'overrideDefaultValue')) return props.overrideDefaultValue;
    return _.last(options).value;
  };

  return (
    <FieldSelect
      {...props}
      selectedDefaultValue={getSelectedDefaultValue()}
      options={_.reverse(_.clone(_.get(props, 'overrideOptions', options)))}
      nonTrackRating={props.nonTrackRating}
      rating
    />
  );
}
